// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* .my-Box2 {
    border: none;
    padding: 5px;
    margin-bottom: 200%;
    font: 24px/36px sans-serif;
    overflow-y: scroll; */
  
    /* Scrollbar styles */
    /* scrollbar-width: thin;
    scrollbar-color: rgb(49, 49, 48) rgb(79, 80, 78);
   */
    /* Track styles */
    /* &::-webkit-scrollbar {
      width: 10px;
      height: 2px;
    }
  
    &::-webkit-scrollbar-track {
      background-color: rgb(235, 238, 231);
    }
   */
    /* Thumb styles */
    /* &::-webkit-scrollbar-thumb {
      background-color: rgb(134, 134, 128);
    }
  
    &::-webkit-scrollbar-thumb:hover {
      background-color: #bdc5bd;
    }
  }.pagination li button {
    color: #0985dd;
  }
  
   */




   .my-Box2 {
  border: none;
  padding: 5px;
  margin-bottom: 2rem; /* Changed from 200% to 2rem */
  font: 24px/36px sans-serif;
  overflow-y: scroll;

  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: rgb(49, 49, 48) rgb(79, 80, 78);
}

/* WebKit (Chrome, Edge, Safari) scrollbar styles */
.my-Box2::-webkit-scrollbar {
  width: 10px;
  height: 2px;
}

.my-Box2::-webkit-scrollbar-track {
  background-color: rgb(235, 238, 231);
}

.my-Box2::-webkit-scrollbar-thumb {
  background-color: rgb(134, 134, 128);
}

.my-Box2::-webkit-scrollbar-thumb:hover {
  background-color: #bdc5bd;
}

/* Pagination button style */
.pagination li button {
  color: #0985dd;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/sessions/style.css"],"names":[],"mappings":";AACA;;;;;yBAKyB;;IAErB,qBAAqB;IACrB;;IAEA;IACA,iBAAiB;IACjB;;;;;;;;IAQA;IACA,iBAAiB;IACjB;;;;;;;;;;;IAWA;;;;;GAKD;EACD,YAAY;EACZ,YAAY;EACZ,mBAAmB,EAAE,8BAA8B;EACnD,0BAA0B;EAC1B,kBAAkB;;EAElB,sBAAsB;EACtB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,cAAc;AAChB","sourcesContent":["\n/* .my-Box2 {\n    border: none;\n    padding: 5px;\n    margin-bottom: 200%;\n    font: 24px/36px sans-serif;\n    overflow-y: scroll; */\n  \n    /* Scrollbar styles */\n    /* scrollbar-width: thin;\n    scrollbar-color: rgb(49, 49, 48) rgb(79, 80, 78);\n   */\n    /* Track styles */\n    /* &::-webkit-scrollbar {\n      width: 10px;\n      height: 2px;\n    }\n  \n    &::-webkit-scrollbar-track {\n      background-color: rgb(235, 238, 231);\n    }\n   */\n    /* Thumb styles */\n    /* &::-webkit-scrollbar-thumb {\n      background-color: rgb(134, 134, 128);\n    }\n  \n    &::-webkit-scrollbar-thumb:hover {\n      background-color: #bdc5bd;\n    }\n  }.pagination li button {\n    color: #0985dd;\n  }\n  \n   */\n\n\n\n\n   .my-Box2 {\n  border: none;\n  padding: 5px;\n  margin-bottom: 2rem; /* Changed from 200% to 2rem */\n  font: 24px/36px sans-serif;\n  overflow-y: scroll;\n\n  /* Firefox scrollbar */\n  scrollbar-width: thin;\n  scrollbar-color: rgb(49, 49, 48) rgb(79, 80, 78);\n}\n\n/* WebKit (Chrome, Edge, Safari) scrollbar styles */\n.my-Box2::-webkit-scrollbar {\n  width: 10px;\n  height: 2px;\n}\n\n.my-Box2::-webkit-scrollbar-track {\n  background-color: rgb(235, 238, 231);\n}\n\n.my-Box2::-webkit-scrollbar-thumb {\n  background-color: rgb(134, 134, 128);\n}\n\n.my-Box2::-webkit-scrollbar-thumb:hover {\n  background-color: #bdc5bd;\n}\n\n/* Pagination button style */\n.pagination li button {\n  color: #0985dd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
